<loading [loading]="loading.isShow" [loadingMessage]="loading.message"></loading>

<div *ngIf="loading.isShow == false && is_signing_link == false">
  <ng-container *ngIf="error_messages.length > 0">
    <ng-container *ngFor="let error_message of error_messages">
      <div class="alert alert-danger">
        <button type="button" class="close" data-dismiss="alert" (click)="removeErrorMessage(error_message)">
          ×
        </button>
        {{ error_message }}
      </div>
    </ng-container>
  </ng-container>
  <div id="lightning_style" [hidden]="edit_document" class="demo-only" style="height: 640px">
    <div class="slds-modal__container">
      <header class="slds-modal__header">
        <h2 id="modal-heading-01" class="slds-text-heading_medium slds-hyphenate">Document Options</h2>
      </header>
      <div class="slds-modal__content slds-p-around_medium" id="modal-content-replace-signer">
        <div class="form-group">
          <ul class="nav nav-tabs">
            <ng-container *ngIf="current_tab === 'setup'">
              <li class="active"><a>1) Setup Document</a></li>
              <li style="pointer-events: none"><a class="no-hover">2) Data Binding</a></li>
            </ng-container>
            <ng-container *ngIf="current_tab === 'pushback'">
              <li style="pointer-events: none"><a class="no-hover">1) Setup Document</a></li>
              <li class="active"><a>2) Data Binding</a></li>
            </ng-container>
          </ul>

          <div class="tab-content">
            <div id="setup" class="{{ setup_class }}">
              <br />
              <label
                for="DocumentNameInput"
                class="col-md-6 control-label"
                style="font-size: 0.9rem; margin-top: 5px"
                >Please enter document name:</label
              >
              <div class="col-md-6">
                <input
                  type="text"
                  class="sn-sf-input full-width"
                  id="DocumentNameInput"
                  value="{{ document_name }}"
                  #DocumentNameInput
                /><br /><br />
              </div>
              <div class="col-md-12">
                <button class="btn btn-neutral btn-block" (click)="openSNDocumentTab()">
                  Edit Document &nbsp;&nbsp;<span class="glyphicon glyphicon-edit"></span>
                </button>
                <br />
                <button class="btn btn-neutral btn-block" (click)="openSNAnnotationsTab()">
                  Add Annotations &nbsp;&nbsp;<span class="glyphicon glyphicon-pencil"></span>
                </button>
              </div>
            </div>

            <div id="pushback" class="{{ pushback_class }}">
              <app-data-binding-base-form
                *ngIf="current_tab === 'pushback'"
                (updateLoadingE)="updateLoadingEvent($event)"
                [document]="selected_pushback_document"
                [recordType]="pushback_type"
                [isNeedShowForm]="display_pushback"
                [sfObjectsSuggestionList]="sfObjectsList"
              >
                <span class="sn-binding-alter-message">
                  <br />
                  Document doesn't contain fields. Please click "Previous" to add fields to document. If you
                  don't want to set data binding you may continue by clicking "Finish".
                </span>
              </app-data-binding-base-form>
            </div>
          </div>
        </div>
      </div>
      <footer class="slds-modal__footer">
        <ng-container *ngIf="current_tab === 'setup'">
          <button
            class="btn btn-primary pull-left"
            (click)="CloneDocumentWithNewName(DocumentNameInput.value, 'pushback')"
          >
            Next
          </button>
        </ng-container>
        <ng-container *ngIf="current_tab === 'pushback'">
          <button class="btn btn-neutral pull-left" (click)="setTabs('setup')">Previous</button>
          <button class="btn btn-primary" (click)="addPushbackDataToDocument(singningLinkFlag)">
            Create Signing Link
          </button>
          <span class="spacer">or</span>
          <button class="btn btn-primary" (click)="addPushbackDataToDocument()">Send Invite</button>
        </ng-container>
        <ng-container *ngIf="current_tab === 'setup'">
          <!--<button class="btn btn-primary" (click)="CloneDocumentWithNewName(DocumentNameInput.value, singningLinkFlag);">Create Signing Link</button>-->
          <button class="btn btn-neutral" (click)="CloneDocumentWithNewName(DocumentNameInput.value, 'send')">
            Skip Document Options
          </button>
        </ng-container>
      </footer>
    </div>
  </div>

  <ng-container *ngIf="edit_document">
    <div class="slds-modal-wrap">
      <div
        role="dialog"
        tabindex="-1"
        aria-labelledby="modal-heading-01"
        class="slds-modal slds-fade-in-open"
        style="width: 100%; top: 0; bottom: 0; padding: 0"
      >
        <div style="width: 100%; max-width: 100%; height: 100%">
          <div class="slds-modal__content overhide" id="modal-content" style="height: 100%; width: 100%">
            <object width="100%" height="100%" [data]="edit_document_url"></object>
          </div>
        </div>
      </div>
      <div class="slds-backdrop slds-backdrop_open"></div>
    </div>
  </ng-container>
</div>

<sn-modal-popup [isShowModal]="loading.isShow == false && is_signing_link">
  <ng-container class="sn-modal-header">
    <h2 class="slds-text-heading_medium slds-hyphenate">Signing Link for "{{ document_name }}"</h2>
  </ng-container>
  <ng-container class="sn-modal-content">
    <span style="display: block; margin-bottom: 5px">Copy and give this link to your signer:</span>
    <input
      type="text"
      class="sn-sf-input full-width"
      #signingLinkInput
      value="{{ signingLinkString + signingLinkParams }}"
      placeholder="loading... please wait"
      readonly
    />
    <!--TODO add logic for additional params (when we should show them and when not)-->
    <!--<label style="margin-top: 7px">-->
    <!--<input type="checkbox" [(ngModel)]="isAllowToInvite" #allowToInvite (change)="changeAdditionalSigningLinkParams()">-->
    <!--<span>Allow signer to send invite</span>-->
    <!--</label>-->
    <!--<label>-->
    <!--<input [disabled]="!isAllowToInvite" type="checkbox" [(ngModel)]="isInviterWillGuest" #inviterWillGuest (change)="changeAdditionalSigningLinkParams()">-->
    <!--<span>Inviter will guest sign signing step 1</span>-->
    <!--</label>-->

    <div *ngIf="isAllowToInvite" class="additional-info">
      <span>Sharing this link will allow the user to send invites to this document on your behalf.</span>
    </div>
  </ng-container>
  <ng-container class="sn-modal-footer">
    <button
      class="btn btn-neutral btn-copy"
      [ngClass]="{ copied: isCopiedToClipboard }"
      (click)="copySigningLinkToClipboard(signingLinkInput)"
    >
      Copy to clipboard
    </button>
    <button class="btn btn-primary" (click)="back_to_templates_page()">Go Back to Start</button>
    <!--<button class="btn btn-neutral" (click)="is_signing_link = false">Cancel</button>-->
  </ng-container>
</sn-modal-popup>

<ng-container *ngIf="is_show_overwritten_info">
  <div class="slds-modal-wrap" style="background: rgba(0, 0, 0, 0.6)">
    <div role="dialog" class="slds-modal slds-fade-in-open" style="width: 400px; top: 120px">
      <div class="slds-modal__container">
        <header class="slds-modal__header">
          <h2 class="slds-text-heading_medium slds-hyphenate">Warning</h2>
        </header>
        <div class="slds-modal__content slds-p-around_medium">
          <span style="display: block; margin-bottom: 5px; font-size: 14px">
            The fields in the selected document have been deleted.<br />
            Instead they were replaced with the fields from a template specified in Template Settings.
          </span>
        </div>
        <footer class="slds-modal__footer">
          <button class="btn btn-primary" (click)="is_show_overwritten_info = false">Ok</button>
        </footer>
      </div>
    </div>
  </div>
</ng-container>
